import { formatImgUrl } from "@/utils/crop";
import { Image } from "antd-mobile";
import React from "react";
import styles from "./index.module.less";
type Props = {
  tabList: any;
  selectedIndex: number;
  onAction?: (item: any, index: number) => void;
};

const VerticalTabComp: React.FC<Props> = ({
  tabList,
  selectedIndex,
  onAction,
}) => {

  return (
    <div className={styles.container}>
      {tabList.map((item: any, index: number) => {
        return (
          <div
            key={index}
            className={`${styles.item} ${index === selectedIndex ? styles.active : ""}`}
            onClick={() => onAction?.(item, index)}>
            {item.isNewProduct ||
              (item.isCustomize &&
                item.customizeNavigationVO?.navIcon) ? (
              <Image
                src={formatImgUrl(
                  item.isNewProduct
                    ? "https://akim-oss.aikucun.com/1bd90f113e7ccbd5111f9cb908d14dccd1b58df6_1749719204193_42.png"
                    : item.customizeNavigationVO?.navIcon,
                  28,
                  28,
                )}
                className={styles.image}
                fit='contain'
              />
            ) : (
              <div className={styles.text}>
                {item.itemName}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default VerticalTabComp;
